import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = ( { strong, className, children } ) => strong ?
    <strong>
        <span className={className} data-sel="progress-goal-level-amount">
            { children }
        </span>
    </strong>
:
    <span className={className} data-sel="progress-goal-level-amount">
        { children }
    </span>
;
Wrapper.propTypes = { strong: PropTypes.bool, className: PropTypes.string, children: PropTypes.node };
Wrapper.defaultProps = { strong: false, className: '' };

export default Wrapper;
